<template>
  <v-container fluid>

    <v-row dense align="center" justify="space-between" no-gutters>
      <v-col cols="12" md="2">
        <label class="menunamestyle ml-10">{{this.$session.get("MENUNAME")}}</label>
      </v-col>
      <v-spacer/>
      <template v-if="grade >= 50">
        <v-col  cols="12" md="3">
          <comdialog :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
        </v-col>
      </template>
    </v-row>

    <v-row align="center" dense>
      <v-spacer/>
      <v-col cols="12" md="2" sm="12" xs="12">
        <v-menu
          v-model="date1"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
          :disabled="!checkdate"
          >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="search_start_date"
              :label="$t('common_search_start')"
              prepend-icon="event"
              readonly outlined dense hide-details
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="search_start_date" @input="date1 = false" :first-day-of-week="0" :locale="$i18n.locale"></v-date-picker>
        </v-menu>      
      </v-col>
      <v-col cols="12" md="2" sm="12" xs="12">
        <v-menu
          v-model="date2"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          :disabled="!checkdate"
          min-width="290px"
          >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="search_end_date"
              :label="$t('common_search_end')"
              prepend-icon="event"
              readonly outlined dense hide-details
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="search_end_date" @input="date2=false" :first-day-of-week="0" :locale="$i18n.locale"></v-date-picker>
        </v-menu>                    
      </v-col>
      <v-col cols="12" md="1" sm="6" xs="6" class="d-flex justify-center">
        <v-checkbox v-model="checkdate" dense :label="$t('common_usedate')"/>
      </v-col>
      <v-col cols="12" md="2" sm="6" xs="6" class="d-flex justify-center">
        <v-btn class="search_btn" elevation="0" outlined large @click="search_run">{{$t("common_ok")}}</v-btn>
        <v-btn class="ml-2" color="#4e6ef7" large rounded @click="startDownload()"><v-icon color="white">cloud_download</v-icon></v-btn>
      </v-col>
    </v-row>

    <v-row dense justify="center">
      <v-col cols="4" md="1" sm="4" xs="4" style="padding:2px">
        <div class="chartsum_round">
          <label class="chartsum_title">{{$t('charteuinfo_col1')}}</label>
          <label class="chartsum_value"  style="font-size:20px">{{ priceToString(sum1) }}</label>
        </div>
      </v-col>
      <v-col cols="4" md="1" sm="4" xs="4" style="padding:2px">
        <div class="chartsum_round">
        <label class="chartsum_title">{{$t('charteuinfo_col2')}}</label>
        <label class="chartsum_value" style="font-size:20px">{{ priceToString(sum2) }}</label>
        </div>
      </v-col>
      <v-col cols="4" md="1" sm="4" xs="4" style="padding:2px">
        <div class="chartsum_round">
        <label class="chartsum_title">{{$t('charteuinfo_col3')}}</label>
        <label class="chartsum_value" style="font-size:20px">{{ priceToString(sum3) }}</label>
        </div>
      </v-col>
      <v-col cols="4" md="1" sm="4" xs="4" style="padding:2px">
        <div class="chartsum_round">
        <label class="chartsum_title">{{$t('charteuinfo_col4')}}</label>
        <label class="chartsum_value" style="font-size:20px">{{ priceToString(sum4) }}</label>
        </div>
      </v-col>
      <v-col cols="4" md="1" sm="4" xs="4" style="padding:2px">
        <div class="chartsum_round">
        <label class="chartsum_title">{{$t('charteuinfo_col5')}}</label>
        <label class="chartsum_value" style="font-size:20px">{{ priceToString(sum5) }}</label>
        </div>
      </v-col>
      <v-col cols="4" md="1" sm="4" xs="4" style="padding:2px">
        <div class="chartsum_round">
        <label class="chartsum_title">{{$t('charteuinfo_col6')}}</label>
        <label class="chartsum_value" style="font-size:20px">{{ priceToString(sum6) }}</label>
        </div>
      </v-col>
      <v-col cols="4" md="1" sm="4" xs="4" style="padding:2px">
        <div class="chartsum_round">
        <label class="chartsum_title">{{$t('charteuinfo_col7')}}</label>
        <label class="chartsum_value" style="font-size:20px">{{ priceToString(sum7) }}</label>
        </div>
      </v-col>
      <v-col cols="4" md="1" sm="4" xs="4" style="padding:2px">
        <div class="chartsum_round">
        <label class="chartsum_title">{{$t('charteuinfo_col8')}}</label>
        <label class="chartsum_value" style="font-size:20px">{{ priceToString(sum8) }}</label>
        </div>
      </v-col>
      <v-col cols="4" md="1" sm="4" xs="4" style="padding:2px">
        <div class="chartsum_round">
        <label class="chartsum_title">{{$t('charteuinfo_col9')}}</label>
        <label class="chartsum_value" style="font-size:20px">{{ priceToString(sum9) }}</label>
        </div>
      </v-col>
      <v-col cols="4" md="1" sm="4" xs="4" style="padding:2px">
        <div class="chartsum_round">
        <label class="chartsum_title">{{$t('charteuinfo_col10')}}</label>
        <label class="chartsum_value" style="font-size:20px">{{ priceToString(sum10) }}</label>
        </div>
      </v-col>
      <v-col cols="4" md="1" sm="4" xs="4" style="padding:2px">
        <div class="chartsum_round">
        <label class="chartsum_title">{{$t('charteuinfo_col11')}}</label>
        <label class="chartsum_value" style="font-size:20px">{{ priceToString(sum11) }}</label>
        </div>
      </v-col>
    </v-row>


    <v-row class="mt-5">
      <v-col>
        <v-simple-table 
          height="70vh" 
          width="100vw"
          dense fixed-header
          class="datatablestyle"
          >
          <template v-slot:default>
            <thead style="height:48px">
              <tr>
                <th class="text-left header_text_style">{{$t('charteuinfo_col12')}}</th>
                <th class="text-left header_text_style">{{$t('charteuinfo_col13')}}</th>
                <th class="text-right header_text_style">{{$t('charteuinfo_col1')}}</th>
                <th class="text-right header_text_style">{{$t('charteuinfo_col2')}}</th>
                <th class="text-right header_text_style">{{$t('charteuinfo_col3')}}</th>
                <th class="text-right header_text_style">{{$t('charteuinfo_col4')}}</th>
                <th class="text-right header_text_style">{{$t('charteuinfo_col5')}}</th>
                <th class="text-right header_text_style">{{$t('charteuinfo_col6')}}</th>
                <th class="text-right header_text_style">{{$t('charteuinfo_col7')}}</th>
                <th class="text-right header_text_style">{{$t('charteuinfo_col8')}}</th>
                <th class="text-right header_text_style">{{$t('charteuinfo_col9')}}</th>
                <th class="text-right header_text_style">{{$t('charteuinfo_col10')}}</th>
                <th class="text-right header_text_style">{{$t('charteuinfo_col11')}}</th>
              </tr>
            </thead>
            <tbody>
              <tr style="background-color:#f0f0f0">
                <td class="text-center"></td>
                <td class="text-right">{{$t('charteuinfo_col14')}}</td>
                <td class="text-right">{{ priceToString(sum1) }}</td>
                <td class="text-right">{{ priceToString(sum2) }}</td>
                <td class="text-right">{{ priceToString(sum3) }}</td>
                <td class="text-right">{{ priceToString(sum4) }}</td>
                <td class="text-right">{{ priceToString(sum5) }}</td>
                <td class="text-right">{{ priceToString(sum6) }}</td>
                <td class="text-right">{{ priceToString(sum7) }}</td>
                <td class="text-right">{{ priceToString(sum8) }}</td>
                <td class="text-right">{{ priceToString(sum9) }}</td>
                <td class="text-right">{{ priceToString(sum10) }}</td>
                <td class="text-right">{{ priceToString(sum11) }}</td>
              </tr>
              <tr v-for="item in list" :key="item.ROWNUM">
                <td class="text-left">{{ item.COM_NAME }}</td>
                <td class="text-left">{{ item.EVENT_NAME }}</td>
                <td class="text-right">{{ priceToString(item.SUM) }}</td>
                <td class="text-right">{{ priceToString(item.MAN)}}</td>
                <td class="text-right">{{ priceToString(item.GIRL) }}</td>
                <td class="text-right">{{ priceToString(item.AGE10) }}</td>
                <td class="text-right">{{ priceToString(item.AGE20) }}</td>
                <td class="text-right">{{ priceToString(item.AGE30) }}</td>
                <td class="text-right">{{ priceToString(item.AGE40) }}</td>
                <td class="text-right">{{ priceToString(item.AGE50) }}</td>
                <td class="text-right">{{ priceToString(item.AGE60) }}</td>
                <td class="text-right">{{ priceToString(item.AGE70) }}</td>
                <td class="text-right">{{ priceToString(item.AGE80) }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>

  </v-container>
</template>
<script>

import moment from 'moment'
import XLSX from 'xlsx'
export default {

  beforeDestroy(){
  },

  mounted(){

    if(this.$session.get("GRADE") < 10){
      this.$alert(this.$t("common_nograde"));
      this.$router.push("Login");
      return;
    }

    this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
    this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
    this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
    this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
    this.grade = this.$session.get("GRADE");
    
    this.search_start_date  = this.$session.get("EVENT_START");
    if(this.search_start_date == null || this.search_start_date == undefined){
      this.search_start_date = moment().subtract(1, 'YEARS').format("YYYY-MM-DD");
    }
    this.search_end_date    = this.$session.get("EVENT_END");
    if(this.search_end_date == null || this.search_end_date == undefined){
      this.search_end_date   = moment().format("YYYY-MM-DD");
    }

    if(this.$session.exists("ADMIN_IDX")){
      this.initpage();
    }else{
      //키값 없으면 로그인으로
      this.$router.push("Login");
    }
  },

  data: () => ({

      date1:false,
      date2:false,
      search_start_date : '',
      search_end_date : '',
      checkdate : true,
      list:[],
      sum1:0,
      sum2:0,
      sum3:0,
      sum4:0,
      sum5:0,
      sum6:0,
      sum7:0,
      sum8:0,
      sum9:0,
      sum10:0,
      sum11:0,

      SEARCH_COM_IDX: null,
      SEARCH_COM_NAME: '',
      SEARCH_EVENT_IDX: null,
      SEARCH_EVENT_NAME: '',
      grade : 0,

  }),

  methods: {
    
    startDownload(){

      this.$confirm(this.$t('common_downexcel2')).then(() => {


        var templist = [];
        this.list.forEach(item=>{
          templist.push({
            "COM_NAME":item.COM_NAME
          , "EVENT_NAME":item.EVENT_NAME
          , "SUM":parseInt(item.SUM)
          , "MAN":parseInt(item.MAN)
          , "GIRL":parseInt(item.GIRL)
          , "AGE10":parseInt(item.AGE10)
          , "AGE20":parseInt(item.AGE20)
          , "AGE30":parseInt(item.AGE30)
          , "AGE40":parseInt(item.AGE40)
          , "AGE50":parseInt(item.AGE50)
          , "AGE60":parseInt(item.AGE60)
          , "AGE70":parseInt(item.AGE70)
          , "AGE80":parseInt(item.AGE80)
          });
        });

        //하단 합계 넣기
        templist.push({
            "COM_NAME":""
          , "EVENT_NAME":this.$t('charteuinfo_col13')
          , "SUM":parseInt(this.sum1)
          , "MAN":parseInt(this.sum2)
          , "GIRL":parseInt(this.sum3)
          , "AGE10":parseInt(this.sum4)
          , "AGE20":parseInt(this.sum5)
          , "AGE30":parseInt(this.sum6)
          , "AGE40":parseInt(this.sum7)
          , "AGE50":parseInt(this.sum8)
          , "AGE60":parseInt(this.sum9)
          , "AGE70":parseInt(this.sum10)
          , "AGE80":parseInt(this.sum11)
        });
        
        var item_sheet = XLSX.utils.json_to_sheet(templist);
                
        //상단 컬럼명 수정
        item_sheet.A1 = {v:this.$t('charteuinfo_col12')};
        item_sheet.B1 = {v:this.$t('charteuinfo_col13')};
        item_sheet.C1 = {v:this.$t('charteuinfo_col1')};
        item_sheet.D1 = {v:this.$t('charteuinfo_col2')};
        item_sheet.E1 = {v:this.$t('charteuinfo_col3')};
        item_sheet.F1 = {v:this.$t('charteuinfo_col4')};
        item_sheet.G1 = {v:this.$t('charteuinfo_col5')};
        item_sheet.H1 = {v:this.$t('charteuinfo_col6')};
        item_sheet.I1 = {v:this.$t('charteuinfo_col7')};
        item_sheet.K1 = {v:this.$t('charteuinfo_col8')};
        item_sheet.K1 = {v:this.$t('charteuinfo_col9')};
        item_sheet.L1 = {v:this.$t('charteuinfo_col10')};
        item_sheet.M1 = {v:this.$t('charteuinfo_col11')};

        //컬럼별 너비
        var wscols = [{wch:20},{wch:30},{wch:10},{wch:10}];
        item_sheet['!cols'] = wscols;

        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, item_sheet, this.$t('charteuinfo_label1'));
        XLSX.writeFile(wb, this.$t('charteuinfo_label1')+'_'+moment().format('YYYYMMDDHHmmss')+'.xlsx');

      });    
      
    },    

    initpage(){
      this.search_run();
    },

    search_run(){

      if(this.grade < 99){
        if(this.SEARCH_COM_IDX == null){
          this.$alert(this.$t('common_select_com'));
          return;
        }
      }

      if(this.checkdate){
        if(this.search_start_date.length < 4){
          this.$alert(this.$t('common_search_start_info1'));
          return;
        }
        if(this.search_end_date.length < 4){
          this.$alert(this.$t('common_search_end_info1'));
          return;
        }
        if(this.search_start_date > this.search_end_date){
          this.$alert(this.$t('common_search_date_error1'));
          return;
        }
      }

      this.$http.post(this.$host+'/api/ChartEventUserInfo',{
            ADMIN_IDX: this.$session.get("ADMIN_IDX")
          , COM_IDX:   this.SEARCH_COM_IDX == undefined ? '' : this.SEARCH_COM_IDX
          , CHECKDATE: this.checkdate
          , search_start_date:this.search_start_date == undefined ? '' : this.search_start_date
          , search_end_date:this.search_end_date == undefined ? '' : this.search_end_date
      },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
      .then((result)=>{

        
        this.loading = false;
        
        if(result.data.resultCode == 0){

            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }
            this.sum1 = 0;
            this.sum2 = 0;
            this.sum3 = 0;
            this.sum4 = 0;
            this.sum5 = 0;
            this.sum6 = 0;
            this.sum7 = 0;
            this.sum8 = 0;
            this.sum9 = 0;
            this.sum10 = 0;
            this.sum11 = 0;
            this.list.splice(0, this.list.length);   //데이터 초기화
            this.list = result.data.resultData;
            this.list.forEach(item =>{
              this.sum1 += parseInt(item.SUM);
              this.sum2 += parseInt(item.MAN);
              this.sum3 += parseInt(item.GIRL);
              this.sum4 += parseInt(item.AGE10);
              this.sum5 += parseInt(item.AGE20);
              this.sum6 += parseInt(item.AGE30);
              this.sum7 += parseInt(item.AGE40);
              this.sum8 += parseInt(item.AGE50);
              this.sum9 += parseInt(item.AGE60);
              this.sum10 += parseInt(item.AGE70);
              this.sum11 += parseInt(item.AGE80);
            })


        }else if(result.data.resultCode == 2){
          //로그인 필요
          this.$alert(this.$t("common_tokener"));
          this.$session.clear("ADMIN_IDX");
          this.$session.clear("COM_IDX");
          this.$session.clear("ACNT_IDX");
          this.$session.clear("GRADE");
          this.$session.clear("COM_NAME");
          this.$session.clear("ACCESSTOKEN");
          this.$session.clear("REFLASHTOKEN");
          this.$router.push('Login');   //로그인 페이지로 이동

        }
      })
      // eslint-disable-next-line no-unused-vars
      .catch((error)=>{
        
        this.loading = false;
        if(error.message == 'Request failed with status code 429')
        {
          this.$alert(this.$t("common_reqer"));
        }else{
          this.$alert(error.message);
        }
      });

    },

    priceToString(price) {
      return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },


    // eslint-disable-next-line no-unused-vars
    comsearchclear(var2){
        this.SEARCH_COM_IDX    = null;
        this.SEARCH_COM_NAME   = '';
        this.SEARCH_EVENT_IDX  = null;
        this.SEARCH_EVENT_NAME = '';
        this.$session.set("COM_IDX",  null);
        this.$session.set("COM_NAME", "");
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
        this.search_run();
    },

    //업체선택 콜백
    comdialogcb(val){
      if(val.NAME.length > 0){
        this.editedItem.COM_NAME = val.NAME;
        this.editedItem.COM_IDX  = val.IDX;
      }else{
        this.$alert(this.$t('common_select_company'));
        return;
      }
    },

    //검색조건 업체 설정
    comsearchcb(val1){
      if(val1.NAME.length > 0){
        this.SEARCH_COM_NAME = val1.NAME;
        this.SEARCH_COM_IDX  = val1.IDX;
        this.$session.set("COM_IDX", val1.IDX);
        this.$session.set("COM_NAME", val1.NAME);
        this.SEARCH_EVENT_IDX = null;
        this.SEARCH_EVENT_NAME = '';
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");

        this.search_start_date = moment(val1.EVENT_START, "YYYY-MM-DD").format("YYYY-MM-DD");
        this.search_end_date  = moment(val1.EVENT_END, "YYYY-MM-DD").format("YYYY-MM-DD");
        this.$session.set("EVENT_START", this.search_start_date);
        this.$session.set("EVENT_END", this.search_end_date);

      }else{
        this.SEARCH_COM_NAME = '';
        this.SEARCH_COM_IDX  = null;
        this.SEARCH_EVENT_IDX = null;
        this.SEARCH_EVENT_NAME = '';
        this.$session.set("COM_IDX",  null);
        this.$session.set("COM_NAME", "");
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");

        this.$session.set("EVENT_START", null);
        this.$session.set("EVENT_END", null);

      }
      this.search_run();
    },



  }
    
}

</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>

</style>